var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"svg-icon",style:({ fontSize: `${_vm.size}px` }),attrs:{"aria-hidden":"true"}},[_c('use',{attrs:{"xlink:href":`#${_vm.icon}`}})])
}
var staticRenderFns = []

export { render, staticRenderFns }